import { render, staticRenderFns } from "./EditRequestedToPage.vue?vue&type=template&id=072b6992"
import script from "./EditRequestedToPage.vue?vue&type=script&lang=js"
export * from "./EditRequestedToPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports